import { Component, OnInit } from '@angular/core';
import {ContentService} from '../../services/content.service';

import { Router, ActivatedRoute, Params } from '@angular/router';
import {Indicator} from '../../models/indicator';

import { timer } from 'rxjs/observable/timer';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
  providers: [ContentService]
})
export class MainComponent implements OnInit {

  title = 'app';
  public loading: Promise<boolean>;

  public images: any;
  public data: any;
  public unique: any;

  public previewToken: any;



  constructor(private _contentService: ContentService,
              private _route: ActivatedRoute,
              private _router: Router,
  ) {
    this.previewToken = null;
  }

  /**@author Lupita Llamas
   * Trae toda la info para mostrar en la tarjeta
   */
  ngOnInit() {
    this.setTime();

    this._route.params.forEach((params: Params) => {
      this.unique = params['unique'];
      if (params['token']) {
        this.previewToken = params['token'];
      }
    });
    if (this.unique !== 'undefined' || this.unique !== '') {
      /*const promise = new Promise((resolve, reject) => {
        setTimeout(() => {*/
          this._contentService.dataTest(this.unique, this.previewToken).subscribe(result => {
            this.images = result.card.images;
            this.data = result;
            const background = this.data.card.background_color !== '' ? this.data.card.background_color : '#fff';
            const text = this.data.card.text_color !== '' ? this.data.card.text_color : '#000';
            $('body').css('background-color', background );
            $('.change-color').css('color', text);
            $('.social:hover').css('color', '#fD4');
            this.setView();
          }, err => {
              if (err.status === 404) {
                this._router.navigate(['']); // Customer didn't found
              } else if (err.status === 400) {
                this._router.navigate(['err400']); // Customer with card inactive
              } else {
                this._router.navigate(['']); // Another mistake
              }
            }
          );
        // }// ,// 100);
     // });
    } else {
      this._router.navigate(['']); // Customer didn't found
    }
  }

  /**@author Lupita Llamas
   * Envia las aperturas de la pag
   */
  public setView() {
    const indicator = new Indicator( this.unique, 0, 0);
    this._contentService.sendStats(indicator).subscribe(result => {
     // console.log('sended');
    }, err => {
     // console.log('error' + err.status);
    });
  }


  public setTime() {
    const numbers = timer(10000, 10000); // Call after 10 second.. Please set your time
    numbers.subscribe(x => {
      const indicator = new Indicator( this.unique, 2, 10);
      this._contentService.sendStats(indicator).subscribe(result => {

      }, err => {
      //  console.log('error' + err.status);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/main/main.component.ts